import { render, staticRenderFns } from "./session-auth-detail.vue?vue&type=template&id=0fcbd236&scoped=true"
import script from "./session-auth-detail.vue?vue&type=script&lang=js"
export * from "./session-auth-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcbd236",
  null
  
)

export default component.exports